import {pushEdapEvent} from '../utils/edap';
import {UPDATE_SEARCH} from './action-types';
import {UNREFINED_KEY} from '../utils/listings';
import {buildSerpUrl} from '../utils/urls';
import {PROPERTY_TYPE_ALL} from '../utils/property-types';
import {getValue, TESTS} from '../utils/abacus';

export function setSearchData(payload) {
    return {type: UPDATE_SEARCH, payload};
}

export function redirect(url, target = 'self') {
    return {type: 'REDIRECT', url, target};
}

export function setRefinements(refinements) {
    return {
        type: 'RECEIVE_REFINEMENTS',
        refinements
    };
}

export function setKeywords(keywords) {
    return {
        type: 'RECEIVE_KEYWORDS',
        keywords
    };
}

export function setSerpUrlDomain(domain) {
    return {
        type: 'RECEIVE_SERP_URL_DOMAIN',
        domain
    };
}

export function showDatesPopup(payload) {
    return {
        type: 'SHOW_DATES_POPUP',
        payload
    };
}

export function hideDatesPopup() {
    return {
        type: 'HIDE_DATES_POPUP'
    };
}

export function setArrivalDate(date) {
    return {
        type: 'RECEIVE_ARRIVAL_DATE',
        date
    };
}

export function setDepartureDate(date) {
    return {
        type: 'RECEIVE_DEPARTURE_DATE',
        date
    };
}

/**
 * Push to EDAP.
 * @param {String} event - event name
 * @param {Object} eventOptions - event options
 * @param {Object} edapOptions - edap options
 * @returns {void}
 */

function reportDatedSearchSubmit(arrivalDate, departureDate, actionLocation) {
    pushEdapEvent(
        'dated.search.submit',
        {
            startdate: arrivalDate,
            enddate: departureDate,
            actionlocation: actionLocation
        },
        {
            delayProcessing: true
        }
    );
}

export function reportSearchSubmit({actionLocation, eventrefinements, eventcategory = '', eventaction, eventlbsuuid = ''}) {
    const isButton =
    ['properties-map-module', 'properties-module', 'destination-infographic'].indexOf(actionLocation) !==
    -1;

    let edapEventName;
    let adls = {
        actionlocation: actionLocation
    };

    if (eventaction) {
        adls.eventaction = eventaction;
    }

    if (eventcategory) {
        adls.eventcategory = eventcategory;
    }

    if (eventlbsuuid) {
        adls.eventlbsuuid = eventlbsuuid;
    }

    if (isButton) {
        edapEventName = 'search.link.click';
        adls.eventrefinements = eventrefinements && parseInt(eventrefinements, 10) ? `filter:${eventrefinements}` : eventrefinements;
    } else {
        edapEventName = 'search.submit';
    }

    pushEdapEvent(edapEventName, adls, {
        delayProcessing: true
    });
}

function getParams({
    datedSearchSubmit,
    arrival,
    departure,
    filterUrl = {},
    keywords,
    propertyType = PROPERTY_TYPE_ALL,
    adultsCount,
    childrenCount,
    filterIds = []
}) {
    const filter = [];

    if (propertyType !== PROPERTY_TYPE_ALL) {
        filter.push(`filter:${propertyType}`);
    }

    const filt = filterUrl.filter;
    if (filt && filt !== propertyType) {
        filter.push(`filter:${filt}`);
    }

    filterIds.forEach((item) => {
        filter.push(`filter:${item}`);
    });

    const datedParam = datedSearchSubmit ? {
        arrival,
        departure
    } : {};

    return {
        q: keywords,
        ...datedParam,
        ...filterUrl,
        filter,
        adultsCount: adultsCount || null,
        childrenCount: childrenCount || null
    };
}

export function goToSerp(options = {}) {
    const {
        actionLocation = null,
        datedSearchSubmit = false,
        eventrefinements = '',
        refinementKey = UNREFINED_KEY,
        reportEdapEvent = true,
        searchLink = false,
        serpUrlFilters = {},
        eventcategory = '',
        target = 'self'
    } = options;

    return (dispatch, getState) => {
        const state = getState();

        const {
            abacus,
            config: {site: {basePath}, isMobile},
            search: {arrivalDate, departureDate, serpUrlDomain: host, keywords, adults, children},
            destination: {propertyType}
        } = state;

        const filterUrl = refinementKey !== UNREFINED_KEY ? serpUrlFilters[refinementKey] || {} : {};
        const params = getParams({
            datedSearchSubmit,
            arrival: arrivalDate,
            departure: departureDate,
            filterUrl,
            keywords,
            propertyType,
            adultsCount: adults,
            childrenCount: children
        });

        if (getValue(abacus, TESTS.MAP_PROPERTIES_REDESIGN_MOBILE) === 1 && isMobile) {
            params.view = 'm';
        }

        const url = buildSerpUrl({
            basePath,
            host,
            params
        });

        if (reportEdapEvent !== false) {
            if (datedSearchSubmit) {
                reportDatedSearchSubmit(arrivalDate, departureDate, actionLocation);
            }

            if (searchLink) {
                reportSearchSubmit({actionLocation, eventrefinements, eventcategory});
            }
        }

        dispatch(redirect(url, target));
    };
}

export function goToPinnedSerp(options = {}) {
    const {
        datedSearchSubmit = false,
        refinementKey = UNREFINED_KEY,
        serpUrlFilters = {},
        target = 'self'
    } = options;

    return (dispatch, getState) => {
        const state = getState();

        const {
            config: {site: {basePath}},
            search: {tripleId, arrivalDate, departureDate, serpUrlDomain: host, keywords, adults, children, filterIds},
            destination: {propertyType}
        } = state;

        const data = {
            'pinnedPropertyListing': tripleId,
            'channel': 'slp'
        };

        const filterUrl = refinementKey !== UNREFINED_KEY ? serpUrlFilters[refinementKey] || {} : {};

        const params = getParams({
            datedSearchSubmit,
            arrival: arrivalDate,
            departure: departureDate,
            filterUrl,
            keywords,
            propertyType,
            adultsCount: adults,
            childrenCount: children,
            filterIds
        });

        const url = buildSerpUrl({
            basePath,
            host,
            params: {
                ...params,
                ...data
            }
        });

        dispatch(redirect(url, target));
    };
}
